"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorPickerInputGroup = void 0;
var _web = require("@react-hookz/web");
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../../../theme/utils/useTheme");
var _Spacer = require("../../../../layout/Spacer");
var _Select = require("../../../../selectV2/Select");
var _colorUtilities = require("../../../colorPickerUtils/colorUtilities");
var _ColorInputPair = require("./components/ColorInputPair");
var _inputs = require("./constants/inputs");
var _ColorPickerInputGroupRoot = require("./styled/ColorPickerInputGroupRoot");
var _SelectWrap = require("./styled/SelectWrap");
const selectOptions = [{
  label: "Hex",
  value: "hex"
}, {
  label: "RGB",
  value: "rgb"
}];
const ColorPickerInputGroup = _ref => {
  let {
    showOpacity,
    className,
    color,
    locale = "en",
    opacity,
    validationCallback,
    onChange,
    onAlphaChange,
    clientId
  } = _ref;
  const rgb = (0, _colorUtilities.setRGBAtoZeroIfNull)((0, _colorUtilities.hex2rgb)(color));
  const [selectValue, setSelectValue] = (0, _react.useState)(selectOptions[0]);
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const [state, setState] = (0, _react.useState)({
    hex: color,
    rvalid: (0, _colorUtilities.validateRGB)(rgb.r),
    gvalid: (0, _colorUtilities.validateRGB)(rgb.g),
    bvalid: (0, _colorUtilities.validateRGB)(rgb.b),
    avalid: (0, _colorUtilities.validateAlpha)(opacity),
    hexvalid: (0, _colorUtilities.validateHexCode)(color, showOpacity || false),
    a: opacity,
    r: rgb.r,
    g: rgb.g,
    b: rgb.b
  });
  const prevProps = (0, _web.usePrevious)({
    opacity,
    color
  });
  const {
    rvalid,
    gvalid,
    bvalid,
    avalid,
    hexvalid
  } = state;
  (0, _react.useEffect)(() => {
    validationCallback(rvalid && gvalid && bvalid && hexvalid && avalid);
  }, [rvalid, gvalid, bvalid, avalid, hexvalid, validationCallback]);
  const changeHandler = (val, which) => {
    // this fires if someone edits the text inputs
    switch (which) {
      case "hex":
        if ((0, _colorUtilities.validateHexCode)(val, showOpacity || false)) {
          const rgb = (0, _colorUtilities.setRGBAtoZeroIfNull)((0, _colorUtilities.hex2rgb)(val));
          setState({
            ...state,
            hex: val,
            hexvalid: true,
            ...rgb,
            rvalid: (0, _colorUtilities.validateRGB)(rgb.r),
            gvalid: (0, _colorUtilities.validateRGB)(rgb.g),
            bvalid: (0, _colorUtilities.validateRGB)(rgb.b)
          });
          onChange(val);
        } else {
          setState({
            ...state,
            hex: val,
            hexvalid: false
          });
        }
        break;
      case "r":
      case "g":
      case "b":
        {
          const valb = parseInt(val);
          if ((0, _colorUtilities.validateRGB)(valb)) {
            const {
              r,
              g,
              b
            } = state;
            const newRgb = {
              r,
              g,
              b,
              [which]: valb
            };
            const hex = (0, _colorUtilities.rgb2hex)(newRgb);
            setState({
              ...state,
              hex,
              [which]: valb,
              [`${which}valid`]: true
            });
            onChange(hex);
          } else {
            setState({
              ...state,
              [which]: val,
              [`${which}valid`]: false
            });
          }
          break;
        }
      case "a":
        {
          const a = +val;
          const avalid = (0, _colorUtilities.validateAlpha)(a);
          setState({
            ...state,
            a,
            avalid
          });
          avalid && onAlphaChange && onAlphaChange(a);
          break;
        }
    }
  };
  (0, _react.useEffect)(() => {
    if (color !== prevProps?.color && color !== state.hex) {
      const rgb = (0, _colorUtilities.setRGBAtoZeroIfNull)((0, _colorUtilities.hex2rgb)(color));
      setState({
        ...state,
        ...rgb,
        hex: color,
        hexvalid: (0, _colorUtilities.validateHexCode)(color, showOpacity || false),
        rvalid: (0, _colorUtilities.validateRGB)(rgb.r),
        gvalid: (0, _colorUtilities.validateRGB)(rgb.g),
        bvalid: (0, _colorUtilities.validateRGB)(rgb.b)
      });
    }
    if (opacity !== prevProps?.opacity && opacity !== state.a) {
      setState({
        ...state,
        a: opacity,
        avalid: (0, _colorUtilities.validateAlpha)(opacity),
        hex: color,
        hexvalid: (0, _colorUtilities.validateHexCode)(color, showOpacity || false)
      });
    }
  }, [color, opacity, prevProps?.color, prevProps?.opacity, showOpacity, state]);
  const selectChangeHandler = value => {
    setSelectValue(value);
  };
  const inputs = showOpacity ? selectValue?.value === "hex" ? _inputs.hexWithAlphaInputs : _inputs.rgbWithAlphaInputs : _inputs.defaultInputs;
  return /*#__PURE__*/_react.default.createElement(_ColorPickerInputGroupRoot.ColorPickerInputGroupRoot, {
    className: className,
    "data-client-id": (0, _lodestarUtils.getClientId)(clientId, "ccpig")
  }, /*#__PURE__*/_react.default.createElement(_Spacer.Spacer, {
    space: "xxSmall",
    orientation: "row"
  }, showOpacity && /*#__PURE__*/_react.default.createElement(_SelectWrap.SelectWrap, {
    themeMode: themeMode
  }, /*#__PURE__*/_react.default.createElement(_Select.Select, {
    isClearable: false,
    isSearchable: false,
    options: selectOptions,
    locale: locale,
    selectedOption: selectValue,
    getOptionKey: option => option.label,
    onChange: selectChangeHandler,
    clientId: (0, _lodestarUtils.getClientId)(clientId, "ccpig-select")
  })), inputs.map(input => {
    const val = state[input.propKey];
    const isValid = state[`${input.propKey}valid`];
    return /*#__PURE__*/_react.default.createElement(_ColorInputPair.ColorInputPair, {
      isValid: isValid,
      key: input.label,
      flexGrow: input.flexGrow,
      width: input.width,
      label: input.label,
      value: val,
      onChange: value => changeHandler(value, input.propKey),
      clientId: (0, _lodestarUtils.getClientId)(clientId, input.clientId),
      allowedCharacters: input.allowedCharacters
    });
  })));
};
exports.ColorPickerInputGroup = ColorPickerInputGroup;
//# sourceMappingURL=ColorPickerInputGroup.js.map